import { useQuery } from 'react-query';
import * as Cookie from 'js-cookie';

import {
  PRISMIC_REF_QUERY_KEY,
  PRISMIC_REF_URL,
  PRISMIC_PREVIEW_COOKIE
} from '../utils/constants';
import { isPrismicPreviewPage } from '../utils';

// get either preview token from server or master ref
// to pass in all subsequent request headers to Prismic endpoints

export default function usePrismicRefQuery() {
  const previewToken = Cookie.get(PRISMIC_PREVIEW_COOKIE);
  const isPreviewPage = isPrismicPreviewPage();
  const queryKey = PRISMIC_REF_QUERY_KEY;

  const query = useQuery({
    queryKey,
    queryFn: () => window.fetch(PRISMIC_REF_URL).then(res => res.json()),
    // if provided, use previewToken instead of ref for all document queries
    enabled: !previewToken || !isPreviewPage
  });

  if (previewToken && isPreviewPage) {
    return {
      ...query,
      queryKey,
      ref: previewToken
    };
  }

  return {
    ...query,
    queryKey,
    ref: query.isSuccess ? query.data.refs[0].ref : null
  };
}
